/*global define*/

define("./Workbench", [
    'jquery',
    //'ui',
    //'touchpunch',
    'bootstrap',
    'underscore',
    'backbone',
    './Vessel',
    './Tool',
    'postal',
    '../resources/lang',
    '../Configuration',
    'interactjs'

], function ($, /*ui, touchpunch,*/ bootstrap, _, Backbone, VesselView, ToolView, postal, lang, Configuration, interact) {
    'use strict';

    var WorkbenchView = Backbone.View.extend({
        template: require('ejs-loader!../templates/Workbench.ejs'),
        events: {
            'drag': 'dragover',
            'drop': 'drop',
            'click .cancelTool': 'disconnectTool',
            'contextmenu': 'openContextMenu',
        },
        initialize: function() {
        },
        render: function() {
            this.model.get('vesselCollection').off('add');
            this.model.get('vesselCollection').on('add', this.addVessel, this);
            this.model.get('toolCollection').off('add');
            this.model.get('toolCollection').on('add', this.addTool, this);
            this.$el.html(this.template({
                workbenches: this.model.get('app').get('workbenches').toJSON(),
                thisBenchCid: this.model.cid,
                currentWorkbenchCid: this.model.get('app').get('currentWorkbenchCid'),
                terms: _.extend({}, lang.workbench, lang.actions, lang.solutionProperties),
                language: language
            }));
            $(".workbench").height($(window).height() - 150);
            this.renderVessels();
            this.renderTools();
            // Use the setTimeout trick...
        },
        openContextMenu: function(event) {
            event.preventDefault();
            $(".vesselContextMenu").css("display", "none");
            var menu = $(".workbenchContextMenu");
            menu.css({
                display: "block",
                top: (event.pageY < $(window).height() / 2) ? event.pageY : event.pageY - menu.height(),
                left: (event.pageX < $(window).width() / 2) ? event.pageX : event.pageX - menu.width()
            });
            setTimeout(() => {
                $(document).one('click', ()=> {
                    menu.css({display: 'none'});
                })
            }, 400)
        },
        renderVessels: function(){
            var vslViews = this.model.get('vesselViews');
            for (var vsl in vslViews){
                var vesselView = vslViews[vsl];
                vesselView.render();
                $($('.workbench')[0]).append(vesselView.el);
            }
        },
        renderTools: function(){
            var toolViews = this.model.get("toolViews");
            for (var tool in toolViews) {
                var toolView = toolViews[tool];
                toolView.render();
                $($(".workbench")[0]).append(toolView.el);
            }
        },
        addItem: function (view) {
            var channel = postal.channel("logger");
            channel.publish("componentAdded", {component: view.model, workbench: this.model});
            var workbenchDOM = $($("#"+this.model.cid)[0]);
            workbenchDOM.append(view.el);
            var dom = $("#"+view.model.cid);
            var doms = [];
            var vslViews = this.model.get("vesselViews");
            var toolViews = this.model.get("toolViews");
            var i;
            for (i in vslViews) {
                doms.push($("#" + vslViews[i].model.cid));
            }
            for (i in toolViews) {
                doms.push($("#" + toolViews[i].model.cid));
            }
            for (i = 0; i < doms.length; i++) {
                if (doms[i].selector !== dom.selector
                    && Math.abs(doms[i].position().left - dom.position().left) < doms[i].width()
                    && Math.abs(doms[i].position().top - dom.position().top) < doms[i].height()) {
                    if (dom.position().left + 2 * dom.width() > workbenchDOM.width()) {
                        dom.css("left", workbenchDOM.position().left);
                        if (dom.position().top + 2 * dom.height() > workbenchDOM.height()) {
                            var popover = $("#workbenchFullPopover");
                            popover.css({display: "block", top: workbenchDOM.position().top,
                                left: workbenchDOM.position().left});
                            $("#workbenchFullWarning").css("display", "block");
                            popover.one("click", function() {
                                popover.css("display", "none");
                            });
                            throw view.model.cid;
                        }
                        else {
                            dom.css("top", dom.position().top + doms[i].height());
                        }
                    }
                    else {
                        dom.css("left", dom.position().left + doms[i].width());
                    }
                    i = -1;
                }
            }
        },
        addVessel: function (vessel) {
            //var vesselClass = "vessel";
            var vesselView = new VesselView({ model: vessel, el: $('<div class="flask">')});
            var vslViews = this.model.get('vesselViews');
            // This would be a place to add the appropriate event handler or information about the parent that would allow calling drag, dragover handlers...

            vslViews[vessel.cid] = vesselView;
            this.model.set('vesselViews', vslViews);
            vesselView.render()

        
            // For each added vessel, add the event handler here...? Useful because I have the appropriate value of this here...
            interact(vesselView.$el[0]).dropzone({
                    accept: '.vessel, .tool',
                    ondrop: this.drop.bind(this),
                    overlap: 0.2,
                    ondragenter: this.dragenter.bind(this),
                    ondragleave: this.dragleave.bind(this),
                })
                .styleCursor(false);
           

  
            this.addItem(vesselView);
        },
        addTool: function (tool) {
            var toolView = new ToolView({model: tool, el: $('<div class="tool ' + tool.get("toolClass") + '">')});
            var toolViews = this.model.get("toolViews");
            toolViews[tool.cid] = toolView;
            this.model.set("toolViews", toolViews);
            toolView.render();

            // For each added tool, add the event handler here...? Useful because I have the appropriate value of this here...
            interact(toolView.el).dropzone({
                accept: '.vessel, .tool',
                ondrop: this.drop.bind(this),
                overlap: 0.4,
                ondragenter: this.dragenter.bind(this),
                ondragleave: this.dragleave.bind(this),
            })
            .styleCursor(false);

            this.addItem(toolView);
        },
        dragenter: function (event) {
            event.target.classList.add('drop-hover')
            var dom1 = $(event.relatedTarget);
            var dom2 = $(event.target);
            var vesselCollection = this.model.get("vesselCollection");
            var toolCollection = this.model.get("toolCollection");
            if (dom1.hasClass("vessel") && dom2.hasClass("vessel")) {
                var sourceVessel = vesselCollection.get(dom1.attr("id")).get("vessel");
                var targetVessel = vesselCollection.get(dom2.attr("id")).get("vessel");
                if (sourceVessel.pours && targetVessel.accepts && !(sourceVessel.vesselClass !== "solid" && targetVessel.vesselClass === "solid")) {
                    dom1.css("cursor", "copy");
                    dom2.css('cursor', 'copy');
                }
                else {
                    dom1.css("cursor", "no-drop");
                    dom2.css('cursor', 'no-drop');
                }
            }
            else if (dom1.hasClass("tool") && dom2.hasClass("vessel")) {
                if (dom1.hasClass("bunsen") && vesselCollection.get(dom2.attr("id")).get("vessel").bunsen || dom1.hasClass("scale") && vesselCollection.get(dom2.attr("id")).get("vessel").scale) {
                    dom1.css("cursor", "copy");
                    dom2.css('cursor', 'copy');
                }
                else {
                    dom1.css("cursor", "no-drop");
                    dom2.css('cursor', 'no-drop');

                }
            }
            else if (dom1.hasClass("vessel") && dom2.hasClass("tool")) {
                if (dom2.hasClass("bunsen") && vesselCollection.get(dom1.attr("id")).get("vessel").bunsen || dom2.hasClass("scale") && vesselCollection.get(dom1.attr("id")).get("vessel").scale) {
                    dom1.css("cursor", "copy");
                    dom2.css('cursor', 'copy');
                }
                else {
                    dom1.css("cursor", "no-drop");
                    dom2.css('cursor', 'no-drop')
                }
            }
            else if (dom1.hasClass("tool") && dom2.hasClass("tool")) {
                dom1.css("cursor", "no-drop");
                dom2.css('cursor', 'no-drop');
            }
            else {
                dom1.css("cursor", "default");
                dom2.css('cursor', 'default');

            }
        },
        dragleave: function (event) {
            event.target.classList.remove('drop-hover')
            var dom1 = $(event.relatedTarget);
            var dom2 = $(event.target);
            dom1.css("cursor", "default");
            dom2.css('cursor', 'default');
        },
        dragover: function (event) {
            var dom1 = $(event.relatedTarget);
            var dom2 = $(event.target);
            var vesselCollection = this.model.get("vesselCollection");
            var toolCollection = this.model.get("toolCollection");
            if (dom1.hasClass("vessel") && dom2.hasClass("vessel")) {
                var sourceVessel = vesselCollection.get(dom1.attr("id")).get("vessel");
                var targetVessel = vesselCollection.get(dom2.attr("id")).get("vessel");
                if (sourceVessel.pours && targetVessel.accepts && !(sourceVessel.vesselClass !== "solid" && targetVessel.vesselClass === "solid")) {
                    dom1.css("cursor", "copy");
                }
                else {
                    dom1.css("cursor", "no-drop");
                }
            }
            else if (dom1.hasClass("tool") && dom2.hasClass("vessel")) {
                if (dom1.hasClass("bunsen") && vesselCollection.get(dom2.attr("id")).get("vessel").bunsen || dom1.hasClass("scale") && vesselCollection.get(dom2.attr("id")).get("vessel").scale) {
                    dom1.css("cursor", "copy");
                }
                else {
                    dom1.css("cursor", "no-drop");
                }
            }
            else if (dom1.hasClass("vessel") && dom2.hasClass("tool")) {
                if (dom2.hasClass("bunsen") && vesselCollection.get(dom1.attr("id")).get("vessel").bunsen || dom2.hasClass("scale") && vesselCollection.get(dom1.attr("id")).get("vessel").scale) {
                    dom1.css("cursor", "copy");
                }
                else {
                    dom1.css("cursor", "no-drop");
                }
            }
            else if (dom1.hasClass("tool") && dom2.hasClass("tool")) {
                dom1.css("cursor", "no-drop");
            }
            else {
                dom1.css("cursor", "default");
            }
        },
        drop: function (event) {
            // These will come from the event
            var dom1 = $(event.relatedTarget);

  

            var dom2 = $(event.target);
            dom1.css("cursor", "default");
            dom2.css('cursor', 'default');
            var channel = postal.channel("logger");
            var vesselCollection = this.model.get("vesselCollection");
            var toolCollection = this.model.get("toolCollection");

            if (dom1.hasClass('dropzone-inactive')) {
                return 0;
            }

            if (dom1.hasClass("vessel") && dom2.hasClass("vessel")) {
                var sourceVessel = vesselCollection.get(dom1.attr("id")).get("vessel");
                var targetVessel = vesselCollection.get(dom2.attr("id")).get("vessel");
                if (sourceVessel.pours && targetVessel.accepts && !(sourceVessel.vesselClass !== "solid" && targetVessel.vesselClass === "solid")) {
                    channel.publish("connectionMade", {dependent: vesselCollection.get(dom1.attr("id")), independent: vesselCollection.get(dom2.attr("id"))});
                    this.initiateTransfer(dom1, dom2);
                }
            }
            else if (dom1.hasClass("tool") && dom2.hasClass("vessel")) {
                if (dom1.hasClass("bunsen") && vesselCollection.get(dom2.attr("id")).get("vessel").bunsen
                    || dom1.hasClass("scale") && vesselCollection.get(dom2.attr("id")).get("vessel").scale) {
                    channel.publish("connectionMade", {
                        dependent: toolCollection.get(dom1.attr("id")),
                        independent: vesselCollection.get(dom2.attr("id"))
                    });
                    this.attachToolToVessel(dom1, dom2);
                }
            }
            else if (dom1.hasClass("vessel") && dom2.hasClass("tool")) {
                if (dom2.hasClass("bunsen") && vesselCollection.get(dom1.attr("id")).get("vessel").bunsen || dom2.hasClass("scale") && vesselCollection.get(dom1.attr("id")).get("vessel").scale) {
                    channel.publish("connectionMade", {
                        dependent: vesselCollection.get(dom1.attr("id")),
                        independent: toolCollection.get(dom2.attr("id"))
                    });
                    this.attachToolToVessel(dom2, dom1);
                }
            }
        },
        initiateTransfer: function (sourceVesselDOM, targetVesselDOM){
            var vsls = this.model.get('vesselCollection');
            vsls.each(function(vsl){
                vsl.set("pour", false);
                vsl.set("accept", false);
                // if (!vsl.get("hasTool")) {
                //     $("#" + vsl.cid).draggable("enable");
                // }
            });
            var targetVessel = vsls.get(targetVesselDOM.attr('id'));
            var sourceVessel = vsls.get(sourceVesselDOM.attr('id'));

            if (targetVessel.get('vessel').accepts && sourceVessel.get('vessel').pours) {
                sourceVessel.set("pour", true);
                targetVessel.set("accept", true);

                // Don't allow dragging a class that is actively transferring
                sourceVessel.set('draggable', false)
                targetVessel.set('draggable', false)

                var workbenchDOM = $($("#"+this.model.cid)[0]);
                var winWidth =  $("#vlab").width();
                var scaleFactor = 1;
                if(winWidth < 768 ){
                    scaleFactor = .5;
                }else if( winWidth >= 768 && winWidth <= 991){
                    scaleFactor = .75;
                }else if( winWidth >= 992 && winWidth <= 1199){
                    scaleFactor = 7/8;
                }
                scaleFactor *= Configuration.userScaleFactor;
                var sourceSvgWidth = sourceVessel.get("vessel").pourDimensions[0] * scaleFactor;
                var targetSvgWidth = targetVessel.get("vessel").dimensions[0] * scaleFactor;
                var acceptX = targetVessel.get("vessel").acceptPoint[0] * scaleFactor;
                var acceptY = targetVessel.get("vessel").acceptPoint[1] * scaleFactor;
                var pourX = sourceVessel.get("vessel").pourPoint[0] * scaleFactor;
                var pourY = sourceVessel.get("vessel").pourPoint[1] * scaleFactor;
                if (targetVesselDOM.position().top < workbenchDOM.height() / 2 && !targetVessel.get("hasTool")) {
                    targetVesselDOM.css("top", sourceVesselDOM.position().top + pourY - acceptY);
                }
                else {
                    sourceVesselDOM.css("top", targetVesselDOM.position().top + acceptY - pourY);
                }
                if (targetVesselDOM.position().left < workbenchDOM.width() / 2 && !targetVessel.get("hasTool")) {
                    targetVesselDOM.css("left", sourceVesselDOM.position().left + sourceVesselDOM.width() / 2 - sourceSvgWidth / 2 + pourX - targetVesselDOM.width() / 2 + targetSvgWidth / 2 - acceptX);
                }
                else {
                    sourceVesselDOM.css("left", targetVesselDOM.position().left + targetVesselDOM.width() / 2 - targetSvgWidth / 2 + acceptX - sourceVesselDOM.width() / 2 + sourceSvgWidth / 2 - pourX);
                }
                if (this.currentTransferMode === "realistic") {
                    this.showRealisticTransferPrompt(sourceVesselDOM.attr("id"), targetVesselDOM.attr("id"));
                }
                else {
                    this.showPreciseTransferPrompt(sourceVesselDOM.attr("id"), targetVesselDOM.attr("id"));
                }
            }
        },
        showPreciseTransferPrompt: function (srcVesselCID, tgtVesselCID) {

            // get vessel objects
            var vsls = this.model.get('vesselCollection');
            var srcVesselDOM = $("#"+srcVesselCID);
            var tgtVesselDOM = $("#"+tgtVesselCID);
            var tgtVessel = vsls.get(tgtVesselCID);
            var srcVessel = vsls.get(srcVesselCID);

            // get appropriate jquery objects
            var popover, transferAmountInput;
            if (srcVessel.get("vessel").vesselClass === "solid") {
                popover = $("#solidTransferPopover");
                transferAmountInput = $("#solidTransferAmountInput");
                transferAmountInput.unbind("keypress");
                if (this.currentTransferMode === "precise") {
                    transferAmountInput.keypress(function (event) {
                        if (event.which == 13) {
                            event.preventDefault();
                            this.doPreciseSolidTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        }
                    }.bind(this));
                }
                else if (this.currentTransferMode === "significantFigures") {
                    transferAmountInput.keypress(function (event) {
                        if (event.which == 13) {
                            event.preventDefault();
                            this.doSigFigTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        }
                    }.bind(this));
                }
            }
            else {
                popover = $("#transferPopover");
                transferAmountInput = $("#transferAmountInput");
                transferAmountInput.unbind("keypress");
                if (srcVessel.get("vessel").vesselClass === "pipette" && srcVessel.get("volume") < srcVessel.get("vessel").drop) {
                    if (this.currentTransferMode === "precise") {
                        transferAmountInput.keypress(function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                this.doPreciseTransfer(transferAmountInput.val(), tgtVessel, srcVessel);
                            }
                        }.bind(this));
                    }
                    else if (this.currentTransferMode === "significantFigures") {
                        transferAmountInput.keypress(function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                this.doPreciseTransfer(transferAmountInput.val(), tgtVessel, srcVessel);
                            }
                        }.bind(this));
                    }
                }
                else {
                    if (this.currentTransferMode === "precise") {
                        transferAmountInput.keypress(function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                this.doPreciseTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                            }
                        }.bind(this));
                    }
                    else if (this.currentTransferMode === "significantFigures") {
                        transferAmountInput.keypress(function (event) {
                            if (event.which == 13) {
                                event.preventDefault();
                                this.doSigFigTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                            }
                        }.bind(this));
                    }
                }
            }

            // position popover
            var offsetParent = tgtVesselDOM.offsetParent();
            var left, top;
            if (tgtVesselDOM.position().left + tgtVesselDOM.width() + popover.width() > offsetParent.width()) {
                left = offsetParent.width() - popover.width();
                if (tgtVesselDOM.position().top > offsetParent.height() * 2 / 3) {
                    top = srcVesselDOM.position().top - 59;
                }
                else {
                    top = tgtVesselDOM.position().top + tgtVesselDOM.height() + 9;
                    if (tgtVessel.get("hasTool"))
                        top += 70;
                }
            }
            else {
                if (srcVesselDOM.position().left + srcVesselDOM.width() > tgtVesselDOM.position().left + tgtVesselDOM.width()) {
                    left = srcVesselDOM.position().left + srcVesselDOM.width();
                }
                else {
                    left = tgtVesselDOM.position().left + tgtVesselDOM.width();
                }
                top = tgtVesselDOM.position().top - 50;
            }
            popover.css('display', 'block');
            popover.css('top', top);
            popover.css('left', left);

            // focus input
            transferAmountInput.val("");
            transferAmountInput.focus();

            // display transfer mode tabs
            var i;
            for (i = 0; i < this.transferModes.length; i++) {
                var tab = $("." + this.transferModes[i]);
                tab.css("display", "block");
                if (this.transferModes[i] === this.currentTransferMode) {
                    tab.addClass("active");
                }
                else {
                    tab.removeClass("active");
                }
            }
            $("." + this.currentTransferMode).addClass("active");
            if (this.currentTransferMode === "significantFigures") {
                var precise = $(".precise");
                precise.unbind("click");
                precise.one("click", function () {
                    popover.css("display", "none");
                    this.currentTransferMode = "precise";
                    this.showPreciseTransferPrompt(srcVesselCID, tgtVesselCID);
                }.bind(this));
            }
            else {
                var significantFigures = $(".significantFigures");
                significantFigures.unbind("click");
                significantFigures.one("click", function () {
                    popover.css("display", "none");
                    this.currentTransferMode = "significantFigures";
                    this.showPreciseTransferPrompt(srcVesselCID, tgtVesselCID);
                }.bind(this));
            }
            var realistic = $(".realistic");
            realistic.unbind("click");
            realistic.one("click", function(){
                popover.css("display", "none");
                this.currentTransferMode = "realistic";
                this.showRealisticTransferPrompt(srcVesselCID, tgtVesselCID);
            }.bind(this));

            // activate cancel button
            var cancel = $(".cancel");
            var warning = $(".inputWarning");
            warning.css("display", "none");
            $(".transferFeedback").css("display", "none");
            cancel.unbind('click');
            cancel.one('click', function(){
                srcVessel.set("pour", false);
                tgtVessel.set("accept", false);

                srcVessel.set('draggable', true);
                tgtVessel.set('draggable', true);

                popover.css('display', 'none');
                warning.css("display", "none");
                $(".transferFeedback").css("display", "none");
                var channel = postal.channel("logger");
                channel.publish("connectionBroken", {dependent: srcVessel, independent: tgtVessel});
            });

            // begin dragging a vessel or tool to cancel transfer
            // Remove this - force clicking cancel...
            // $(".vessel, .tool").mousedown(function(){
            //     srcVessel.set("pour", false);
            //     tgtVessel.set("accept", false);

            //     srcVessel.set('draggable', true);
            //     tgtVessel.set('draggable', true);


            //     popover.css('display', 'none');
            //     warning.css("display", "none");
            //     $(".transferFeedback").css("display", "none");
            //     var channel = postal.channel("logger");
            //     channel.publish("connectionBroken", {dependent: srcVessel, independent: tgtVessel});
            // });

            // display withdraw button if using a pipette
            var withdrawButton = $("#withdrawButton");
            if (srcVessel.get("vessel").vesselClass === "pipette") {
                withdrawButton.css("display", "block");
                withdrawButton.unbind("click");
                withdrawButton.on("click", function(){
                    this.doPreciseTransfer(transferAmountInput.val(), tgtVessel, srcVessel);
                    transferAmountInput.focus();
                }.bind(this));
                if (srcVessel.get("volume") > srcVessel.get("vessel").drop)
                    $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", srcVessel.get("name")).replace("TARGET", tgtVessel.get("name")));
                else
                    $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", tgtVessel.get("name")).replace("TARGET", srcVessel.get("name")));
            }
            else {
                withdrawButton.css("display", "none");
                $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", srcVessel.get("name")).replace("TARGET", tgtVessel.get("name")));
            }

            // activate transfer button
            if (srcVessel.get("vessel").vesselClass === "solid") {
                var solidTransferButton = $("#solidTransferButton");
                solidTransferButton.unbind("click");
                if (this.currentTransferMode === "precise") {
                    solidTransferButton.on("click", function () {
                        this.doPreciseSolidTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        transferAmountInput.focus();
                    }.bind(this));
                }
                else if (this.currentTransferMode === "significantFigures") {
                    solidTransferButton.on("click", function () {
                        this.doSigFigTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        transferAmountInput.focus();
                    }.bind(this));
                }
            }
            else {
                var transferButton = $("#transferButton");
                transferButton.unbind("click");
                if (this.currentTransferMode === "precise") {
                    transferButton.on("click", function () {
                        this.doPreciseTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        transferAmountInput.focus();
                    }.bind(this));
                }
                else if (this.currentTransferMode === "significantFigures") {
                    transferButton.on("click", function () {
                        this.doSigFigTransfer(transferAmountInput.val(), srcVessel, tgtVessel);
                        transferAmountInput.focus();
                    }.bind(this));
                }
            }
        },
        showRealisticTransferPrompt: function (srcVesselCID, tgtVesselCID) {

            // get vessel objects
            var vsls = this.model.get('vesselCollection');
            var srcVesselDOM = $("#"+srcVesselCID);
            var tgtVesselDOM = $("#"+tgtVesselCID);
            var tgtVessel = vsls.get(tgtVesselCID);
            var srcVessel = vsls.get(srcVesselCID);

            // position popover
            var popover = $("#realisticTransferPopover");
            var offsetParent = tgtVesselDOM.offsetParent();
            var left, top;
            if (tgtVesselDOM.position().left + tgtVesselDOM.width() + popover.width() > offsetParent.width()) {
                left = offsetParent.width() - popover.width();
                if (tgtVesselDOM.position().top > offsetParent.height() * 2 / 3) {
                    top = srcVesselDOM.position().top - 59;
                }
                else {
                    top = tgtVesselDOM.position().top + tgtVesselDOM.height() + 9;
                }
            }
            else {
                if (srcVesselDOM.position().left + srcVesselDOM.width() > tgtVesselDOM.position().left + tgtVesselDOM.width()) {
                    left = srcVesselDOM.position().left + srcVesselDOM.width();
                }
                else {
                    left = tgtVesselDOM.position().left + tgtVesselDOM.width();
                }
                top = tgtVesselDOM.position().top - 50;
            }
            popover.css('display', 'block');
            popover.css('top', top);
            popover.css('left', left);

            // display transfer mode tabs
            var i;
            for (i = 0; i < this.transferModes.length; i++) {
                var tab = $("." + this.transferModes[i]);
                tab.css("display", "block");
                if (this.transferModes[i] === this.currentTransferMode) {
                    tab.addClass("active");
                }
                else {
                    tab.removeClass("active");
                }
            }
            var precise = $(".precise");
            precise.unbind("click");
            precise.one("click", function(){
                popover.css("display", "none");
                this.currentTransferMode = "precise";
                this.showPreciseTransferPrompt(srcVesselCID, tgtVesselCID);
            }.bind(this));
            var significantFigures = $(".significantFigures");
            significantFigures.unbind("click");
            significantFigures.one("click", function(){
                popover.css("display", "none");
                this.currentTransferMode = "significantFigures";
                this.showPreciseTransferPrompt(srcVesselCID, tgtVesselCID);
            }.bind(this));

            // activate cancel button
            var cancel = $(".cancel");
            var warning = $(".inputWarning");
            warning.css("display", "none");
            $(".transferFeedback").css("display", "none");
            cancel.unbind('click');
            cancel.one('click', function(){
                srcVessel.set("pour", false);
                tgtVessel.set("accept", false);

                srcVessel.set('draggable', true)
                tgtVessel.set('draggable', true)

                popover.css('display', 'none');
                warning.css("display", "none");
                feedback.css("display", "none");
                var channel = postal.channel("logger");
                channel.publish("connectionBroken", {dependent: srcVessel, independent: tgtVessel});
            });

            // begin dragging a vessel or tool to cancel transfer
            $(".vessel, .tool").on('pointerdown', function(){
                srcVessel.set("pour", false);
                tgtVessel.set("accept", false);

                srcVessel.set('draggable', true)
                tgtVessel.set('draggable', true)

                popover.css('display', 'none');
                warning.css("display", "none");
                feedback.css("display", "none");
                var channel = postal.channel("logger");
                channel.publish("connectionBroken", {dependent: srcVessel, independent: tgtVessel});
            });

            var progress = $("#realisticTransferProgress");

            // display withdraw button if using a pipette
            var realisticWithdrawButton = $("#realisticWithdrawButton");
            if (srcVessel.get("vessel").vesselClass === "pipette") {
                if (srcVessel.get("volume") > srcVessel.get("vessel").drop)
                    $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", tgtVessel.get("name")).replace("TARGET", srcVessel.get("name")));
                else $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", srcVessel.get("name")).replace("TARGET", tgtVessel.get("name")));
                realisticWithdrawButton.css("display", "block");
                realisticWithdrawButton.unbind("pointerdown");
                var slowWithdraw, fastWithdraw;
                var realisticWithdrawAmount;
                realisticWithdrawButton.on("pointerdown", function(){
                    realisticWithdrawAmount = 0;
                    warning.css("display", "none");
                    feedback.css("display", "none");
                    slowWithdraw = setInterval(function(){
                        if (holdTime > 10) {
                            progress.css("width", 25 + 225 * realisticWithdrawAmount / (srcVessel.get("vessel").maxVolume * 1000));
                        }
                        else {
                            progress.css("width", 25);
                        }
                        progress.html(realisticWithdrawAmount.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " mL");
                    }, 100);
                    var holdTime = 0;
                    var drop = srcVessel.get("vessel").drop * 1000;
                    fastWithdraw = setInterval(function(){
                        if (holdTime > 10) {
                            realisticWithdrawAmount += drop + 0.1 * Math.random() * drop;
                        }
                        else {
                            realisticWithdrawAmount = 0.02;
                        }
                        if (realisticWithdrawAmount > Math.ceil(tgtVessel.get("volume") * 1000)){
                            warning.html(lang.workbench.notEnoughWarning[language]);
                            warning.css("display", "block");
                            clearInterval(fastWithdraw);
                            realisticWithdrawAmount = tgtVessel.get("volume") * 1000;
                        }
                        else if (realisticWithdrawAmount/1000+srcVessel.get("volume") > srcVessel.get("vessel").maxVolume){
                            warning.html(lang.workbench.pipetteOverfillWarning[language]);
                            warning.css("display", "block");
                            clearInterval(fastWithdraw);
                            realisticWithdrawAmount = (srcVessel.get("vessel").maxVolume - srcVessel.get("volume")) * 1000;
                        }
                        holdTime++;
                    }, 50);
                }.bind(this));
                realisticWithdrawButton.unbind("pointerup");
                realisticWithdrawButton.on("pointerup", function(){
                    clearInterval(fastWithdraw);
                    clearInterval(slowWithdraw);
                    this.model.pour(tgtVesselDOM.attr("id"), srcVesselDOM.attr("id"), realisticWithdrawAmount);
                    feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", realisticWithdrawAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                    //feedback.html(realisticWithdrawAmount.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " mL transferred.");
                    feedback.css("display", "block");
                    progress.css("width", 0);
                }.bind(this));
            }
            else {
                realisticWithdrawButton.css("display", "none");
                $(".transferVessels").html(lang.workbench.fromTo[language].replace("SOURCE", srcVessel.get("name")).replace("TARGET", tgtVessel.get("name")));
            }

            // activate transfer button
            var realisticTransferButton = $("#realisticTransferButton");
            realisticTransferButton.unbind("pointerdown");
            var slowPour, fastPour;
            var realisticTransferAmount;
            var feedback = $(".transferFeedback");
            realisticTransferButton.on("pointerdown", function(){
                realisticTransferAmount = 0;
                var drop = srcVessel.get("vessel").drop * 1000;
                warning.css("display", "none");
                feedback.css("display", "none");
                slowPour = setInterval(function(){
                    if (holdTime > 10 || (srcVessel.get("vessel").vesselClass !== "pipette" && srcVessel.get("vessel").vesselClass !== "burette")) {
                        progress.css("width", 25 + 225 * realisticTransferAmount / (srcVessel.get("vessel").maxVolume * 1000));
                    }
                    else {
                        progress.css("width", 25);
                    }
                    if (srcVessel.get("vessel").vesselClass === "solid") {
                        progress.html((realisticTransferAmount * srcVessel.get("solution").getDensity()).toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " g");
                    }
                    else {
                        progress.html(realisticTransferAmount.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " mL");
                    }
                }, 100);
                var holdTime = 0;
                fastPour = setInterval(function(){
                    if (holdTime > 10 || (srcVessel.get("vessel").vesselClass !== "pipette" && srcVessel.get("vessel").vesselClass !== "burette")) {
                        realisticTransferAmount += drop + 0.1 * Math.random() * drop;
                    }
                    else if (srcVessel.get("vessel").vesselClass === "pipette") {
                        realisticTransferAmount = 0.02;
                    }
                    else if (srcVessel.get("vessel").vesselClass === "burette") {
                        realisticTransferAmount = 0.05;
                    }
                    if (realisticTransferAmount > Math.ceil(srcVessel.get("volume") * 1000)){
                        warning.html(lang.workbench.notEnoughWarning[language]);
                        warning.css("display", "block");
                        clearInterval(fastPour);
                        realisticTransferAmount = srcVessel.get("volume") * 1000;
                    }
                    else if (realisticTransferAmount/1000+tgtVessel.get("volume") > tgtVessel.get("vessel").maxVolume){
                        warning.html(lang.workbench.overfillWarning[language]);
                        warning.css("display", "block");
                        clearInterval(fastPour);
                        realisticTransferAmount = (tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume")) * 1000;
                    }
                    holdTime++;
                }, 50);
            }.bind(this));
            realisticTransferButton.unbind("pointerup");
            realisticTransferButton.on("pointerup", function(){
                clearInterval(fastPour);
                clearInterval(slowPour);
                this.model.pour(srcVesselDOM.attr("id"), tgtVesselDOM.attr("id"), realisticTransferAmount);
                if (srcVessel.get("vessel").vesselClass === "solid")
                    feedback.html(lang.workbench.massTransferred[language].replace("AMOUNT", (realisticTransferAmount * srcVessel.get("solution").getDensity()).toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                else
                    feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", realisticTransferAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                feedback.css("display", "block");
                progress.css("width", 0);
            }.bind(this));
        },
        doPreciseTransfer: function (input, srcVessel, tgtVessel) {
            var transferAmount = parseFloat(input);
            var warning = $(".inputWarning");
            warning.css("display", "none");
            var feedback = $(".transferFeedback");
            feedback.css("display", "none");
            if (isNaN(transferAmount) || transferAmount < 0){
                transferAmount = 0;
                warning.html(lang.workbench.invalidAmountWarning[language]);
                warning.css("display", "block");
            }
            else if (transferAmount > Math.ceil(srcVessel.attributes.volume * 1000)){
                transferAmount = (srcVessel.get("volume") < tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume")) ? srcVessel.get("volume") : tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume");
                transferAmount *= 1000;
                warning.html(lang.workbench.notEnoughWarning[language]);
                warning.css("display", "block");
                feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", transferAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                feedback.css("display", "block");
            }
            else if (transferAmount/1000+tgtVessel.attributes.volume > tgtVessel.attributes.vessel.maxVolume){
                transferAmount = (tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") < srcVessel.get("volume")) ? tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") : srcVessel.get("volume");
                transferAmount *= 1000;
                warning.html(lang.workbench.overfillWarning[language]);
                warning.css("display", "block");
                feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", transferAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                feedback.css("display", "block");
            }
            this.model.pour(srcVessel.cid, tgtVessel.cid, transferAmount);
            feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", transferAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
            feedback.css("display", "block");
        },
        doPreciseSolidTransfer: function (input, srcVessel, tgtVessel) {
            var transferAmount = parseFloat(input);
            var solid = srcVessel.get("solution");
            var weight = solid.getSolutionWeight();
            var volume = solid.getVolume();
            var warning = $(".inputWarning");
            warning.css("display", "none");
            var feedback = $(".transferFeedback");
            feedback.css("display", "none");
            if (isNaN(transferAmount) || transferAmount < 0) {
                transferAmount = 0;
                warning.html(lang.workbench.invalidAmountWarning[language]);
                warning.css("display", "block");
            }
            else if (transferAmount > weight) {
                transferAmount = (volume < tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume")) ? volume : tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume");
                transferAmount *= 1000;
                warning.html(lang.workbench.notEnoughSolidWarning[language]);
                warning.css("display", "block");
            }
            else if (transferAmount * volume / weight + tgtVessel.get("volume") > tgtVessel.get("vessel").maxVolume) {
                transferAmount = (tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") < volume) ? tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") : volume;
                transferAmount *= 1000;
                warning.html(lang.workbench.solidOverfillWarning[language]);
                warning.css("display", "block");
            }
            else {
                transferAmount = transferAmount * volume * 1000 / weight;
            }
            this.model.pour(srcVessel.cid, tgtVessel.cid, transferAmount);
            feedback.html(lang.workbench.massTransferred[language].replace("AMOUNT", (transferAmount * weight / (volume * 1000)).toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
            //feedback.html((transferAmount * weight / (volume * 1000)).toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " g transferred.");
            feedback.css("display", "block");
        },
        doSigFigTransfer: function (transferAmount, srcVessel, tgtVessel) {
            var warning = $(".inputWarning");
            warning.css("display", "none");
            var feedback = $(".transferFeedback");
            feedback.css("display", "none");

            var text = transferAmount;
            var original = text;

            // Parse the number, keeping track of the last significant digit
            // along with a count of the number of non-zero digits.
            var value = 0;
            var lastDigitPos = 0;
            var digitCount = 0;

            var pastDecimal = false;
            var invalid = false;

            while (text.length > 0 && !invalid) {
                var current = text.charAt(0);

                if (pastDecimal) {
                    if (!isNaN(current)) {
                        if (lastDigitPos > 0) {
                            lastDigitPos = -1;
                        }
                        else {
                            lastDigitPos--;
                        }

                        if (current !== '0') {
                            digitCount++;

                            var power = Math.pow(10, lastDigitPos);
                            value += parseInt(current) * power;
                        }
                    }
                    else {
                        invalid = true;
                    }
                }
                else if (!isNaN(current)) {
                    if (current === '0') {
                        lastDigitPos++;
                    }
                    else {
                        lastDigitPos = 0;
                        digitCount++;
                    }

                    value *= 10;
                    value += parseInt(current);
                }
                else if (current === '.') {
                    pastDecimal = true;
                }
                else {
                    invalid = true;
                }

                text = text.substring(1);
            }

            if (value > 0 && !invalid) {
                var src = srcVessel.get("vessel");
                var tgt = tgtVessel.get("vessel");

                // Compare the lastSignificantDigit with the roundoffTolerance
                if ((src.vesselClass === "pipette" || tgt.vesselClass === "pipette") && (src.name !== "Disposable Pipette" && tgt.name !== "Disposable Pipette") && src.name !== "Solid Bottle") {
                    var pipette;
                    if (src.vesselClass === "pipette") {
                        pipette = src;
                    }
                    else {
                        pipette = tgt;
                    }

                    var tick = pipette.maxVolume * 1000;
                    var power = Math.log(tick) / Math.log(5);
                    power = Math.round(power) - 1;

                    power = (power < 0) ? 0 : power;

                    tick /= Math.pow(5, power);
                    tick = Math.floor(tick);
                    tick *= Math.pow(5, power);

                    var volume = Math.floor(tick);

                    if (value !== volume) {
                        warning.html(lang.workbench.invalidPipetteSigFigWarning[language].replace("AMOUNT", volume));
                        //warning.html("Invalid amount! <br> A pipette can only precisely transfer its maximum volume, in this case " + volume + ".00.");
                        warning.css("display", "block");
                    }
                    else if (lastDigitPos !== -2) {
                        warning.html(lang.workbench.invalidSigFigWarning[language].replace("AMOUNT", volume+".00"));
                        //warning.html("Invalid amount! <br> Watch those significant digits! Perhaps you meant " + volume + ".00?");
                        warning.css("display", "block");
                    }
                    else {
                        this.model.pour(srcVessel.cid, tgtVessel.cid, transferAmount);
                    }
                }
                else {
                    var r = src.roundoffTolerance * 1000;
                    r = Math.log(r) / Math.log(10);
                    var s = Math.ceil(r);

                    if ((s < 0 && lastDigitPos !== s && !(s === -1 && lastDigitPos === s - 1 && digitCount === 1))
                        || (s > -1 && lastDigitPos < s && !(lastDigitPos === s - 1 && digitCount === 1))) {
                        if (lastDigitPos < s) {
                            var diff = Math.abs(lastDigitPos - s);
                            if (s > -1 && lastDigitPos < 0) {
                                diff++;
                            }
                            if (diff > original.length) {
                                diff = original.length;
                            }
                            var end = original.length - diff;
                            original = original.substring(0, end);

                            var x = s;

                            while (x > 0) {
                                original += "0";
                                x--;
                            }
                        }
                        else {
                            var diff = Math.abs(s - lastDigitPos);

                            if (lastDigitPos > -1) {
                                original += ".";
                                diff -= lastDigitPos;
                            }

                            while (diff > 0) {
                                original += "0";
                                diff--;
                            }
                        }

                        var allZeros = true;
                        var x;
                        for (x = 0; x < original.length; x++) {
                            var current = original.charAt(x);
                            if (current !== '.' && current !== '0') {
                                allZeros = false;
                                break;
                            }
                        }

                        if (allZeros) {
                            var minimum = Math.pow(10, s);
                            if (minimum >= 1) {
                                original = Math.floor(minimum).toString();
                            }
                            else {
                                original = minimum.toString();
                            }
                        }

                        warning.html(lang.workbench.invalidSigFigWarning[language].replace("AMOUNT", original));
                        //warning.html("Invalid Amount! <br> Watch those significant digits! Perhaps you meant " + original + "?");
                        warning.css("display", "block");
                    }
                    else {
                        // Fudge the value by a random value:
                        r = src.roundoffTolerance * 1000;

                        if (value < r) {
                            r = Math.min(value, r / 3);
                        }

                        var random = (Math.random() - 0.5) * 2;
                        random *= r;

                        if (src.vesselClass === "solid") {
                            var solid = srcVessel.get("solution");
                            var weight = solid.getSolutionWeight();
                            var solidVolume = solid.getVolume();
                            var transferAmount = (weight > 0) ? (value + random) * solidVolume * 1000 / weight : 0;
                            if (transferAmount > Math.ceil(srcVessel.attributes.volume * 1000)){
                                transferAmount = (srcVessel.get("volume") < tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume")) ? srcVessel.get("volume") : tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume");
                                transferAmount *= 1000;
                            }
                            else if (transferAmount/1000+tgtVessel.attributes.volume > tgtVessel.attributes.vessel.maxVolume){
                                transferAmount = (tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") < srcVessel.get("volume")) ? tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") : srcVessel.get("volume");
                                transferAmount *= 1000;
                            }
                            this.model.pour(srcVessel.cid, tgtVessel.cid, transferAmount);
                            feedback.html(lang.workbench.massTransferred[language].replace("AMOUNT", (transferAmount * weight / (solidVolume * 1000)).toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                            //feedback.html((transferAmount * weight / (solidVolume * 1000)).toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " g transferred.");
                            feedback.css("display", "block");
                        }
                        else {
                            var transferAmount = value + random;
                            if (transferAmount > Math.ceil(srcVessel.attributes.volume * 1000)){
                                transferAmount = (srcVessel.get("volume") < tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume")) ? srcVessel.get("volume") : tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume");
                                transferAmount *= 1000;
                            }
                            else if (transferAmount/1000+tgtVessel.attributes.volume > tgtVessel.attributes.vessel.maxVolume){
                                transferAmount = (tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") < srcVessel.get("volume")) ? tgtVessel.get("vessel").maxVolume - tgtVessel.get("volume") : srcVessel.get("volume");
                                transferAmount *= 1000;
                            }
                            this.model.pour(srcVessel.cid, tgtVessel.cid, transferAmount);
                            feedback.html(lang.workbench.volumeTransferred[language].replace("AMOUNT", transferAmount.toLocaleString(language, {maximumFractionDigits: 2, minimumFractionDigits: 2})));
                            //feedback.html(transferAmount.toLocaleString(language, {maximumSignificantDigits: 3, minimumSignificantDigits: 3}) + " mL transferred.");
                            feedback.css("display", "block");
                        }
                    }
                }
            }
            else {
                invalid = true;
            }


        },
        attachToolToVessel: function (toolDOM, vesselDOM) {
            var tools = this.model.get("toolCollection");
            var tool = tools.get(toolDOM.attr("id"));
            var channel = postal.channel("scale");
            var subscription = channel.subscribe("weightChanged_"+vesselDOM.attr("id"), function(data){
                tool.set("weight", tool.get("weight") + data.difference);
            });
            var vsls = this.model.get("vesselCollection");
            var vessel = vsls.get(vesselDOM.attr("id"));

            vessel.set("hasTool", true);
            vessel.set('draggable', false);
            tool.set('vesselId', vesselDOM.attr('id'));
            tool.set('vessel', vessel);
            tool.set('subscription', subscription);
            
            // This might need some sort of Cancel button to remove the connection - easier than all of this dragging to break the connection.
            
            // Modifier could do this?

            // Need something to replace thise? 
        
            // toolDOM.droppable("disable");
            toolDOM.addClass('dropzone-inactive');
            toolDOM.removeClass('draggable');
            const vesselName = vessel.get('name');
            
            var workbenchDOM = $($("#"+this.model.cid)[0]);
            var winWidth =  $("#vlab").width();
            var scaleFactor = 1;
            if(winWidth < 768 ){
                scaleFactor = .5;
            }else if( winWidth >= 768 && winWidth <= 991){
                scaleFactor = .75;
            }else if( winWidth >= 992 && winWidth <= 1199){
                scaleFactor = 7/8;
            }
            scaleFactor *= Configuration.userScaleFactor;
            var contactPoint = tool.get("tool").contactPoint;
            var contactX = contactPoint[0] * scaleFactor;
            var contactY = contactPoint[1] * scaleFactor;
            if (vesselDOM.position().top < workbenchDOM.height() / 2)
                toolDOM.css("top", vesselDOM.position().top + vesselDOM.height() - contactY);
            else
                vesselDOM.css("top", toolDOM.position().top - vesselDOM.height() + contactY);
            if (vessel.get("detailView"))
                toolDOM.css("left", vesselDOM.position().left + vesselDOM.width() / 4 - contactX);
            else
                toolDOM.css("left", vesselDOM.position().left + vesselDOM.width() / 2 - contactX);

            tool[tool.get("tool").toolClass](vessel, true);

        },
        disconnectTool: function (event) {
            const toolId = event.target.parentElement.id;
            const toolDOM = $(document.getElementById(toolId));

            const tools = this.model.get("toolCollection");
            const tool = tools.get(toolId);

            const vesselId = tool.get('vesselId');
            const vesselDOM = $(document.getElementById(vesselId));

            const vsls = this.model.get("vesselCollection");
            const vessel = vsls.get(vesselDOM.attr("id"));


            if (vessel.get("hasTool")) {
                    tool.get('subscription').unsubscribe();
                    tool.set('subscription', null)
                    

                    toolDOM.removeClass("dropzone-inactive");
                    vessel.set('draggable', true);
                    toolDOM.addClass('draggable');

                    vessel.set("hasTool", true);
                    tool.set('vesselId', null); // No vesselId
                    tool.set('vessel', null);
                    
                    // Move the tool down a bit to show it's disconnected
                    toolDOM.css("top", toolDOM.position().top + 20);

                    tool[tool.get("tool").toolClass](vessel, false);
                    var logger = postal.channel("logger");
                    logger.publish("connectionBroken", {dependent: vessel, independent: tool});
            } else {
                console.log("Vessel has no tool")
                console.log(vessel)
                console.log(tool)
            }
        },
        loadTransferModes: function (transferModes) {
            this.transferModes = transferModes;
            this.currentTransferMode = this.transferModes[0];
        }
    });

    return WorkbenchView;
});
